/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { FeatureToggle } from '@core/reb-feature-toggle';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService extends FeatureToggle {
  constructor() {
    super();
  }
}
